module.exports = __webpack_public_path__ + "static/uni_ford-911116b9e4a2d2414d9422ace7729ccc.png";